import React from "react";
import { useNavigate } from "react-router-dom";
import { ChevronLeftIcon } from "../../assets/icons/ChevronLeftIcon";
import styles from "./TgBotDialogWithUser.module.scss";
import MessageContainer from "../MessageContainer/MessageContainer";
import Markdown from "react-markdown";
import { LoadingComponent } from "../LoadingComponent/LoadingComponent";
import Button from "../../ui/Button/Button";
import { useSelector } from "react-redux";

export const TgBotDialogWithUser = ({ userName }) => {
  const navigate = useNavigate();

  const dialog = useSelector((state) => state?.dialog?.activeTgBotDialog);
  const isLoading = useSelector((state) => state?.dialog?.isLoadingTgBotDialog);

  const histories = dialog?.histories;

  const handleGoBack = () => {
    navigate("");
  };

  const formatMessages = (role, message) => {
    return role === "user" ? message : <Markdown children={message} />;
  };

  if (isLoading) {
    return <LoadingComponent />;
  }

  return (
    <div className={styles.container}>
      {histories.length > 0 ? (
        <>
          <div className={styles.header} onClick={handleGoBack}>
            <ChevronLeftIcon width={12} height={16} fill={"black"} />
            <div className={styles.title}>
              Диалог с пользователем <strong>{userName}</strong>
            </div>
          </div>

          <div className={styles.chatPanel}>
            {histories
              ?.slice()
              .reverse()
              .map((message, index) => {
                return (
                  <MessageContainer
                    message={formatMessages(message?.role, message?.content)}
                    role={message?.role}
                    key={index}
                  />
                );
              })}
          </div>
        </>
      ) : (
        <div className={styles.noHistory}>
          <div>
            С пользователем <strong>{userName}</strong> нет истории
          </div>

          <Button
            titleClassName={styles.titleBtn}
            title={"Вернуться назад"}
            onClick={handleGoBack}
          />
        </div>
      )}
    </div>
  );
};
